import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';

import { TicketsService } from '@app/services/tickets.service';
import {
  getPropertyTicketList,
  getPropertyTicketListFailed,
  getPropertyTicketListSuccess,
  getTicketList,
  getTicketListFailed,
  getTicketListSuccess,
  markTicketAsDone,
  markTicketAsDoneFailed,
  markTicketAsDoneSuccess,
} from '@main-application/tickets/store/actions/tickets.actions';
import { SnackbarErrorMessage } from '@ui-components/components/customized-snackbar/snackbar-message.enum';
import { SnackbarService } from '@ui-components/components/customized-snackbar/snackbar.service';

@Injectable()
export class TicketsEffects {
  constructor(
    private actions$: Actions,
    private ticketsService: TicketsService,
    private snackbarService: SnackbarService
  ) {}

  getTicketList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getTicketList),
      switchMap(action =>
        this.ticketsService.getTicketsByAssigneeId(action.assigneeId).pipe(
          map(ticketList => getTicketListSuccess({ ticketList })),
          catchError(() => {
            this.snackbarService.error(SnackbarErrorMessage.RetrievingTicketList);
            return of(getTicketListFailed());
          })
        )
      )
    )
  );

  getPropertyTicketList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getPropertyTicketList),
      switchMap(action =>
        this.ticketsService.getTicketsByPropertyId(action.propertyId).pipe(
          map(list => getPropertyTicketListSuccess({ ticketList: list || [] })),
          catchError(() => {
            this.snackbarService.error(SnackbarErrorMessage.RetrievingTicketList);
            return of(getPropertyTicketListFailed());
          })
        )
      )
    )
  );

  markTicketAsDone$ = createEffect(() =>
    this.actions$.pipe(
      ofType(markTicketAsDone),
      mergeMap(action =>
        this.ticketsService.update(action.turnoverTicket).pipe(
          map(updatedTicket => markTicketAsDoneSuccess({ updatedTicket })),
          catchError(() => {
            this.snackbarService.error(SnackbarErrorMessage.UpdatingTicket);
            return of(markTicketAsDoneFailed());
          })
        )
      )
    )
  );
}
